import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierListController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierListController.php
* @route '/api/dossier'
*/
const GetDossierListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierListController.url(options),
    method: 'get',
})

GetDossierListController.definition = {
    methods: ["get","head"],
    url: '/api/dossier',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierListController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierListController.php
* @route '/api/dossier'
*/
GetDossierListController.url = (options?: RouteQueryOptions) => {
    return GetDossierListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierListController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierListController.php
* @route '/api/dossier'
*/
GetDossierListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierListController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierListController.php
* @route '/api/dossier'
*/
GetDossierListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierListController.url(options),
    method: 'head',
})

export default GetDossierListController